import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Statistic } from 'antd';
import { useGetCargoItems } from 'api/cargo-items/use-get-cargo-items.ts';
import { calculateAverageCargoPrice } from 'shared/utils/cargos/calculate-cost-per-item.ts';
import { numberFormatter } from 'shared/utils/numbers/formatter.ts';
import { round10 } from 'shared/utils/numbers/round.ts';
import { CardUi } from 'components/common/card-ui';
import type { ICargoStatisticsProps } from './types';

export const CargoStatistics: React.FC<ICargoStatisticsProps> = (props) => {
  const { cargo } = props;
  const { t } = useTranslation();

  const { data: cargoItems } = useGetCargoItems({ cargoId: cargo.id });

  const averagePrice = calculateAverageCargoPrice(cargo);

  return (
    <CardUi>
      <Flex gap='large'>
        <Statistic title={t('common:items')} value={cargoItems?.data.length || '-'} />
        <Statistic title={t('common:LDM')} value={cargo.totalLDM} />
        <Statistic
          title={t('common:weight')}
          suffix='kg'
          value={`${cargo.totalWeight} / ${cargo.calculatedTotalWeight}`}
        />
        <Statistic title={t('common:volume')} suffix='m³' value={cargo.totalVolume} />
        {averagePrice ? (
          <Statistic
            title={t('common:average_price')}
            suffix={averagePrice.suffix}
            value={numberFormatter(round10(averagePrice.value))}
          />
        ) : null}
      </Flex>
    </CardUi>
  );
};
